import { createContext, type ReactNode, useContext } from "react";
import { type ProductData } from "~/domains/product/types/ProductData";

import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";

const context = createContext<ProductData | null>(null);

export const ProductContext = context.Provider;
export const useProductContext = ({ product: external }: { product?: ProductData } = {}) => {
  const fromContext = useContext(context);
  const product = external ?? fromContext;
  if (!product) {
    throw new Error("Missing Product");
  }
  return product;
};

const ExtendedContext = createContext<ProductDescriptor | null>(null);

export const ProductDescriptorContext = ({
  value,
  children,
}: {
  value: ProductDescriptor | null;
  children?: ReactNode;
}) => {
  return (
    <ExtendedContext.Provider value={value}>
      <ProductContext value={value?.base ?? null}>{children}</ProductContext>
    </ExtendedContext.Provider>
  );
};
export const useProductDescriptorContext = ({
  productDescriptor: external,
}: { productDescriptor?: ProductDescriptor } = {}) => {
  const fromContext = useContext(ExtendedContext);
  const productDescriptor = external ?? fromContext;
  if (!productDescriptor) {
    throw new Error("Missing Product Descriptor");
  }
  return productDescriptor;
};
